<head>

</head>
<body style="background: #424242;
display: flex;
align-content: flex-start;
flex-wrap: nowrap;
flex-direction: column;
justify-content: flex-start;
align-items: center;
height:100%">

  <h2 style="text-align: center;
  color: grey;
  font-family: roboto;
  font-weight: 200;
  ">Safety Inspection</h2>
  <div *ngFor="let item of incidents; let indexOfElement = index;" style="display:flex">

    <div>
      <img style="max-width: 500px; max-height: 500px;" [src]=" 'https://fastfieldphotos.s3.amazonaws.com/' + item.Infraction_pic"/>
    </div>

    <div style="color: lightgrey;
    margin-left: 20px;">
      <h3 style="text-align: center;">Citation: {{item.Citation_listpick[0]}}</h3>
      <h4 style="text-align: center;">{{item.CytationType_txt}}</h4>



      <h4 style="font-size: 16px;
      font-weight: 200;">{{item.HazardType_txt}}</h4>
      <h4 style="font-size: 16px;
      font-weight: 200;">{{item.OSHAStandard_listpick[0]}}</h4>
      <h5 style="font-size:14px;">Points: {{item.IssuePoints_number}}</h5>
      <h5 style="font-size:14px;">Occurrences: {{item.Occurrences_number}}</h5>
      <h5 style="font-size:14px;">Severity: {{item.Severity_listpick[0]}}</h5>

    </div>


  </div>

</body>
